<script setup lang="ts">

import { usePresentation } from '@/modules/Presentation/Types';
import { useLead } from "../../Types/Lead";
import { Map } from '../../Types/Map';

const lead = useLead();
const presentation = usePresentation();
presentation.backgroundImage = '/images/sample/gkr-watermark.png';
presentation.onSetNext = () => ({ section: Map.YourGoals, page: 0 });

</script>

<template>

    <Page class="overflow-hidden">
    
        <div class="flex flex-col items-center justify-center h-full px-12">

            <Image src="logo-small.png" class="w-[18rem] mb-10" />

            <h1 class="text-2xl font-semibold mb-1">
                Why join GKR Karate
            </h1>

            <h1 class="text-xl mb-8">
                Feel stronger. Think sharper. Be Confident.
            </h1>

            <ul class="text-lg pb-14">
                <li>🛡 <strong>Self Defence</strong> – Learn real skills to feel safer and more in control.</li>
                <li>💪 <strong>Fitness</strong> – Improve strength, flexibility, and energy—no matter your level.</li>
                <li>🧠 <strong>Focus</strong> – Boost discipline, concentration, and goal-setting.</li>
                <li>❤️ <strong>Respect</strong> – For instructors, classmates, and most importantly—yourself.</li>
                <li>👨‍👩‍👧‍👦 <strong>Family</strong> Friendly – Train together, grow together.</li>
                <li>🤝 <strong>Friendships</strong> – Be part of a positive community that supports you.</li>
            </ul>
            
        </div>

    </Page>

</template>